import { render, staticRenderFns } from "./ChangeTradePwdModal.vue?vue&type=template&id=514669ec&scoped=true"
import script from "./ChangeTradePwdModal.vue?vue&type=script&lang=js"
export * from "./ChangeTradePwdModal.vue?vue&type=script&lang=js"
import style0 from "./ChangeTradePwdModal.vue?vue&type=style&index=0&id=514669ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514669ec",
  null
  
)

export default component.exports